import { useCallback } from 'react';

import { gaiaClient as baseGaiaClient } from '@/client/gaia';

import { useAuth } from './use-auth';

/**
 * Hook that provides an auth-aware Gaia client.
 * This hook uses the auth context to automatically include authentication headers.
 */
export const useGaiaClient = () => {
  const { getAccessToken } = useAuth();

  const gaiaClient = useCallback(
    async <TRequest, TResponse>(
      params: Omit<Parameters<typeof baseGaiaClient<TRequest, TResponse>>[0], 'getAccessToken'>
    ) => {
      return baseGaiaClient({
        ...params,
        getAccessToken,
      });
    },
    [getAccessToken]
  );

  return gaiaClient;
};
